import React, { useState, useEffect } from 'react';
import { USER_PROFILE, USER_ROLE } from '../../services/auth';

const DriverExpenseModal = ({ driver, onClose, onSave, initialData, dataErrors }) => {
  const [form, setForm] = useState({
    driver: driver,
    expense_type: '',
    amount: '',
    reason: '',
    remarks: '',
    date: new Date().toISOString().slice(0, 10),
    supporting_doc: null,
    needs_confirmation: false,
  });
  const role = localStorage.getItem(USER_ROLE);
  const showConfirmation = (role == 'admin');

  useEffect(() => {
    if (initialData) {
      setForm(prev => ({
        ...prev,
        ...initialData,
        date: initialData.date || prev.date,
        needs_confirmation: initialData.needs_confirmation || false,
      }));
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm({ ...form, [name]: checked });
    } else if (files) {
      setForm({ ...form, [name]: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  const handleFileClick = () => {
    document.getElementById('attachmentInput').click();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">{initialData ? 'Edit' : 'Add'} Expense</h2>
        <form onSubmit={handleSubmit} className="space-y-4 [&_input[type='text']]:uppercase [&_textarea]:uppercase [&_select]:uppercase">
          <div>
            <label className="block text-sm">Charges Type</label>
            <select
              name="expense_type"
              value={form.expense_type}
              onChange={handleChange}
              className="w-full border px-2 py-1 rounded"
              required
            >
              <option value="">-- Select --</option>
              <option value="incentive">Incentive</option>
              <option value="overtime">Overtime</option>
              <option value="others">Others</option>
            </select>
            {dataErrors.expense_type && (
                <p className="text-red-500 text-sm mt-1">{dataErrors.expense_type[0]}</p>
            )}
          </div>
          {(form.expense_type == 'others') && (<div>
            <label className="block text-sm">Reason</label>
            <input
              type="text"
              name="reason"
              value={form.reason}
              onChange={handleChange}
              className="w-full border px-2 py-1 rounded"
              required
            />
            {dataErrors.reason && (
                <p className="text-red-500 text-sm mt-1">{dataErrors.reason[0]}</p>
            )}
          </div>
          )}
          <div>
            <label className="block text-sm">Amount</label>
            <input
              name="amount"
              type="number"
              value={form.amount}
              onChange={handleChange}
              className="w-full border px-2 py-1 rounded"
              required
            />
            {dataErrors.amount && (
                <p className="text-red-500 text-sm mt-1">{dataErrors.amount[0]}</p>
            )}
          </div>
          <div>
            <label className="block text-sm">Date</label>
            <input
              type="date"
              name="date"
              value={form.date}
              onChange={handleChange}
              className="w-full border px-2 py-1 rounded"
              required
            />
            {dataErrors.date && (
                <p className="text-red-500 text-sm mt-1">{dataErrors.date[0]}</p>
            )}
          </div>
          <div>
            <label className="block text-sm">Remarks</label>
            <input
              type="text"
              name="remarks"
              value={form.remarks}
              onChange={handleChange}
              className="w-full border px-2 py-1 rounded"
            />
            {dataErrors.remarks && (
                <p className="text-red-500 text-sm mt-1">{dataErrors.remarks[0]}</p>
            )}
          </div>
          <div>
            <label className="block text-sm mb-1">Attachment</label>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={handleFileClick}
                className="bg-gray-200 px-3 py-1 rounded border"
              >
                {form.supporting_doc ? 'Change File' : 'Upload File'}
              </button>
              {form.supporting_doc && <span className="text-sm">{form.supporting_doc.name}</span>}
            </div>
            <input
              id="attachmentInput"
              type="file"
              name="supporting_doc"
              accept="image/*,application/pdf"
              onChange={handleChange}
              className="hidden"
            />
          </div>

          {showConfirmation && (
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                name="needs_confirmation"
                checked={form.needs_confirmation}
                onChange={handleChange}
              />
              <label className="text-sm">Need Confirmation</label>
            </div>
          )}
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 px-4 py-2 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DriverExpenseModal;
